import { useTranslation } from '@gem/modules/i18n';

import { useCopyToClipboard } from 'APP/hooks/useCopyToClipboard/useCopyToClipboard';
import { Features } from 'APP/packages/features/Features';
import { User } from 'STORE/Users/User/User';

interface IProfileNicknamePresenter {
  copyToClipboard(): void;
}

export function useProfileNicknamePresenter(user: User): IProfileNicknamePresenter {
  const { t } = useTranslation();

  const canCopyDeepLink = user.isMe && Features.isUserDeepLinkEnabled();

  const copyData = canCopyDeepLink ? user.deepLink : user.displayNickname;
  const message = canCopyDeepLink ? t('common_link_copied') : t('profile_user_nickname_copied');

  const copyToClipboard = useCopyToClipboard(copyData || '', message);

  return {
    copyToClipboard,
  };
}
